<template>
    <div class="room-category">
        <div class="row">
            <div class="col-xl-10 ">
                <div class="row">
                    <div class="col-xl-24">
                        <div class="p-3 p-xl-0">
                            <h3>{{a.area.DisplayName}}</h3>
                            <div v-html="a.area.Description"> </div>
                        </div>
                        <div class="room-category-gallery">
                            <single-image-gallery v-bind:images="a.area.Images"></single-image-gallery>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-22 offset-1 col-xl-14 offset-xl-0">
                <room-panel v-for="ar in a.areaRooms"
                            v-bind:key="ar.roomType.Key"
                            v-bind:leg="leg"
                            v-bind:requiresDogButNone="requiresDogButNone"
                            v-bind:roomType="ar.roomType"></room-panel>

            </div>
        </div>
    </div>

</template>

<script>

    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';
    import RoomPanel from '../components/RoomPanel.vue';

    export default {
        name: 'RoomCategoryPanel',
     
        components: {
            RoomPanel,
            SingleImageGallery,

        },
        props: {
            leg: String,
            a: Object,
            requiresDogButNone: Boolean
        }
    }
</script>




